import React from 'react';
import { useConversations } from '../../hooks/useConversations';
import { useLayout } from '../../contexts/LayoutContext';
import ConversationItem from './ConversationItem';
import ShowMoreButton from './ShowMoreButton';
import { SkeletonConversationItem } from '../common/SkeletonLoader';

const ConversationList = () => {
  const { navCollapsed } = useLayout();
  const { conversations, loading, error, hasMore } = useConversations(15);

  // Don't render the list at all when the nav is collapsed
  if (navCollapsed) {
    return null;
  }

  if (loading) {
    return (
      <div className="conversation-list">
        {[...Array(5)].map((_, index) => (
          <SkeletonConversationItem key={index} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="conversation-list">
        <div className="conversation-list-error">Failed to load conversations</div>
      </div>
    );
  }

  if (conversations.length === 0) {
    return null;
  }

  return (
    <div className="conversation-list">
      {conversations.map((conversation) => (
        <ConversationItem
          key={conversation.id}
          conversation={conversation}
        />
      ))}
      {hasMore && <ShowMoreButton />}
    </div>
  );
};

export default ConversationList;